// Lazy libsodium loader for the NC1 (libsodium) E2EE modules.
//
// Dynamic import() keeps the ~1MB sodium bundle out of the initial chunk —
// same pattern E2EEHelper uses for e3kit. vite.config.js aliases
// 'libsodium-wrappers-sumo' to the self-contained CJS build (the package's
// ESM build has a broken internal import); sumo is required because the
// recovery-code wrap runs Argon2id (crypto_pwhash) in the browser.

let sodiumPromise = null

export function getSodium() {
  if (!sodiumPromise) {
    sodiumPromise = (async () => {
      const mod = await import('libsodium-wrappers-sumo')
      const sodium = mod.default ?? mod
      await sodium.ready
      return sodium
    })()
  }
  return sodiumPromise
}
